import { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, CheckCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, formatApiErrorDetail } from "@/lib/api";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
    } catch {
      // generic confirmation regardless of outcome
    } finally {
      setLoading(false);
      setDone(true);
    }
  };

  return (
    <div className="pt-20 min-h-screen bg-[#F4F5F7] flex items-center justify-center px-4" data-testid="forgot-password-page">
      <div className="w-full max-w-md bg-white border border-zinc-200 rounded-md p-8">
        <h1 className="font-display text-2xl font-black uppercase text-white mb-2">Reset Password</h1>
        {done ? (
          <div className="text-center py-4" data-testid="forgot-password-confirmation">
            <CheckCircle2 className="h-10 w-10 text-[#FF6B00] mx-auto mb-4" />
            <p className="text-sm text-zinc-600 mb-6">
              If that email is registered, a reset link has been sent. The link expires in 1 hour.
            </p>
          </div>
        ) : (
          <>
            <p className="text-sm text-zinc-500 mb-6">Enter your admin email and we'll send a reset link.</p>
            <form onSubmit={submit} className="space-y-4">
              <div>
                <Label className="text-xs font-mono uppercase tracking-wider text-zinc-500">Email</Label>
                <Input
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="bg-white border-zinc-300 text-zinc-900 focus-visible:ring-[#FF6B00] rounded-sm"
                  data-testid="forgot-email-input"
                />
              </div>
              <Button
                type="submit"
                disabled={loading}
                className="w-full h-12 bg-[#FF6B00] hover:bg-[#FF8533] text-black font-bold uppercase tracking-wider rounded-sm"
                data-testid="forgot-submit-button"
              >
                {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Send Reset Link"}
              </Button>
            </form>
          </>
        )}
        <Link to="/admin/login" className="block text-center text-xs text-zinc-500 hover:text-[#FF6B00] mt-5 transition-colors" data-testid="back-to-login-link">
          Back to sign in
        </Link>
      </div>
    </div>
  );
}
